/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_Save_Cancelled_ErrorInputs */

const en_explorer_display_save_cancelled_error = /** @type {(inputs: Explorer_Display_Save_Cancelled_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving project was cancelled`)
};

const fr_explorer_display_save_cancelled_error = /** @type {(inputs: Explorer_Display_Save_Cancelled_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrement du projet annule`)
};

const de_explorer_display_save_cancelled_error = /** @type {(inputs: Explorer_Display_Save_Cancelled_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Rettungsprojekt wurde abgesagt`)
};

const it_explorer_display_save_cancelled_error = /** @type {(inputs: Explorer_Display_Save_Cancelled_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il salvataggio del progetto è stato annullato`)
};

const ru_explorer_display_save_cancelled_error = /** @type {(inputs: Explorer_Display_Save_Cancelled_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проект спасения был отменен.`)
};

const es_explorer_display_save_cancelled_error = /** @type {(inputs: Explorer_Display_Save_Cancelled_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El proyecto de ahorro fue cancelado`)
};

const zh_cn2_explorer_display_save_cancelled_error = /** @type {(inputs: Explorer_Display_Save_Cancelled_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拯救项目被取消`)
};

const ja_explorer_display_save_cancelled_error = /** @type {(inputs: Explorer_Display_Save_Cancelled_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトの保存はキャンセルされました`)
};

const hi_explorer_display_save_cancelled_error = /** @type {(inputs: Explorer_Display_Save_Cancelled_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बचत परियोजना रद्द कर दी गई`)
};

const pt_pt2_explorer_display_save_cancelled_error = /** @type {(inputs: Explorer_Display_Save_Cancelled_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O projeto de poupança foi cancelado.`)
};

/**
* | output |
* | --- |
* | "Saving project was cancelled" |
*
* @param {Explorer_Display_Save_Cancelled_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_save_cancelled_error = /** @type {((inputs?: Explorer_Display_Save_Cancelled_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_Save_Cancelled_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_display_save_cancelled_error(inputs)
	if (locale === "de") return de_explorer_display_save_cancelled_error(inputs)
	if (locale === "it") return it_explorer_display_save_cancelled_error(inputs)
	if (locale === "ru") return ru_explorer_display_save_cancelled_error(inputs)
	if (locale === "es") return es_explorer_display_save_cancelled_error(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_display_save_cancelled_error(inputs)
	if (locale === "ja") return ja_explorer_display_save_cancelled_error(inputs)
	if (locale === "hi") return hi_explorer_display_save_cancelled_error(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_display_save_cancelled_error(inputs)
	return en_explorer_display_save_cancelled_error(inputs)
});